import React, { useState, useEffect } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;


function Students() {

  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [editStudent, setEditStudent] = useState(null);
  const [routes, setRoutes] = useState([]);
  const navigate = useNavigate();
  const [expandedRow, setExpandedRow] = useState(null);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  useEffect(() => {
    fetchStudents();

    api.get(`${API}/conveyance`)

      .then(res => setRoutes(res.data))
      .catch(err => console.log(err));

  }, []);

  const fetchStudents = () => {

    api.get(`${API}/students`)

      .then(res => setStudents(res.data))
      .catch(err => console.log(err));
  };

  // 🔄 UPDATE
  const handleUpdate = () => {

    if (!editStudent.name || !editStudent.class_name) {
      alert("Please fill required fields");
      return;
    }


    api.put(`${API}/update-student`, editStudent)

      .then(() => {
        alert("Student Updated");
        setEditStudent(null);
        fetchStudents();
      })
      .catch(err => console.log(err));
  };

  const handleEditChange = (field, value) => {
    setEditStudent({ ...editStudent, [field]: value });
  };

  // 🔍 SEARCH
  const filtered = students.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    String(s.admno).includes(search)
  );

  // 🗑 DELETE (SOFT)
  const handleDelete = (admNo) => {
    if (!window.confirm("Delete this student?")) return;


    api.put(`${API}/delete-student/${admNo}`)

      .then(() => {
        alert("Deleted");
        fetchStudents();
      })
      .catch(err => console.log(err));
  };

  // 📤 EXPORT
  const handleExport = () => {
    let csv = "AdmNo,Name,Father's Name,Mother's Name,Address,Class,Section,AdmissionType,phone,Route\n";

    filtered.forEach(s => {
      const routeName =
        routes.find(r => r.routeno === s.routeno)?.routename || "No Route";

      csv += [
        s.admno,
        s.name,
        s.fathername,
        s.mothername || "",
        s.address || "",
        s.class_name,
        s.section,
        s.admissiontype || "New",
        s.phone,
        routeName
      ].join(",") + "\n";
    });

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "students.csv";
    a.click();
  };


  // 🖨 PRINT
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="print-area" style={{ padding: 20 }}>


      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2>Students</h2>

        <div className="no-print" style={{ display: "flex", gap: "10px" }}>

          <button onClick={handleExport} style={exportBtn}>
            ⬇ Export
          </button>

          <button onClick={handlePrint} style={printBtn}>
            🖨 Print
          </button>

          <button
            onClick={() => navigate("/add-student")}
            style={addStudentBtn}
          >
            + Add Student
          </button>

        </div>
      </div>

      {/* 🔍 SEARCH */}
      <div className="no-print">
        <input
          placeholder="Search by Name / Adm No"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginBottom: "15px", padding: "8px", width: "300px" }}
        />
      </div>

      {/* 📋 TABLE */}
      <table style={{
        width: "100%",
        borderCollapse: "collapse",
        background: "white"
      }}>
        <thead>
          <tr>
            <th style={{ width: "30px" }}></th>
            <th style={th}>Adm No</th>
            <th style={th}>Name</th>
            <th style={th}>Class</th>
            <th style={th}>Section</th>
            <th style={th}>Admission</th>
            <th style={th}>phone</th>
            <th style={th}>Address</th>
            <th style={th}>Route</th>
            <th className="no-print" style={th}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {filtered.map((s) => (
            <React.Fragment key={s.admno}>

              {/* MAIN ROW */}
              <tr
                onClick={() => navigate(`/student/${s.admno}`)}
                style={{ cursor: "pointer" }}
              >
                <td
                  style={{ textAlign: "center", width: "30px", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setExpandedRow(expandedRow === s.admno ? null : s.admno);
                  }}
                >
                  {expandedRow === s.admno ? "▼" : "▶"}
                </td>

                <td style={td}>{s.admno}</td>
                <td style={td}>{s.name}</td>
                <td style={td}>{s.class_name}</td>
                <td style={td}>{s.section}</td>

                <td style={{
                  ...td,
                  textAlign: "center"
                }}>
                  <span style={{
                    padding: "4px 8px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    background: s.admissiontype === "Old" ? "#dbeafe" : "#dcfce7",
                    color: s.admissiontype === "Old" ? "#1d4ed8" : "#166534"
                  }}>
                    {s.admissiontype || "New"}
                  </span>
                </td>

                <td style={td}>{s.phone}</td>
                <td style={td}>{s.address}</td>

                <td style={td}>
                  {routes.find(r => r.routeno === s.routeno)?.routename || "No Route"}
                </td>

                <td className="no-print" style={td}>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditStudent({ ...s });
                      }}
                      style={{ ...editBtn, marginRight: "6px" }}
                    >
                      Edit
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(s.admno);
                      }}
                      style={deleteBtn}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>

              {/* 🔽 EXPANDED ROW */}
              {expandedRow === s.admno && (
                <tr>
                  <td colSpan="12" style={{
                    background: "#f9fafb",
                    padding: "12px"
                  }}>
                    <b>Father:</b> {s.fathername} &nbsp; | &nbsp;
                    <b>Mother:</b> {s.mothername}
                  </td>
                </tr>
              )}

            </React.Fragment>
          ))}

        </tbody>
      </table>

      {/* ✏️ EDIT POPUP */}
      {editStudent && (
        <div style={overlayStyle}>

          <div style={popupStyle}>
            <h3>Edit Student</h3>

            <input
              value={editStudent.name}
              onChange={(e) => handleEditChange("name", e.target.value)}
              placeholder="Name"
              style={inputStyle}
            />

            <input
              value={editStudent.fathername}
              onChange={(e) => handleEditChange("fathername", e.target.value)}
              placeholder="Father Name"
              style={inputStyle}
            />

            <input
              value={editStudent.mothername || ""}
              onChange={(e) => handleEditChange("mothername", e.target.value)}
              placeholder="Mother Name"
              style={inputStyle}
            />

            <input
              value={editStudent.address || ""}
              onChange={(e) => handleEditChange("address", e.target.value)}
              placeholder="Address"
              style={inputStyle}
            />

            <select
              value={editStudent.class_name}
              onChange={(e) => handleEditChange("class_name", e.target.value)}
              style={inputStyle}
            >
              <option>Nursery</option>
              <option>LKG</option>
              <option>UKG</option>
              <option>One</option>
              <option>Two</option>
              <option>Three</option>
              <option>Four</option>
              <option>Five</option>
              <option>Six</option>
              <option>Seven</option>
              <option>Eight</option>
              <option>Nine</option>
              <option>Ten</option>
            </select>

            <select
              value={editStudent.section}
              onChange={(e) => handleEditChange("section", e.target.value)}
              style={inputStyle}
            >
              <option>A</option>
              <option>B</option>
              <option>C</option>
              <option>D</option>
            </select>

            <select
              value={editStudent.admissiontype || "New"}
              onChange={(e) => handleEditChange("admissiontype", e.target.value)}
              style={inputStyle}
            >
              <option value="New">New Admission</option>
              <option value="Old">Old Admission</option>
            </select>

            <input
              value={editStudent.phone}
              onChange={(e) => handleEditChange("phone", e.target.value)}
              placeholder="phone"
              style={inputStyle}
            />

            {/* ✅ ROUTES FROM DB */}
            <select
              value={editStudent.routeno}
              onChange={(e) => handleEditChange("routeno", Number(e.target.value))}
              style={inputStyle}
            >
              <option value="">Select Route</option>

              {routes.map(r => (
                <option key={r.routeno} value={r.routeno}>
                  {r.routeno} - {r.routename} (₹{r.routefare})
                </option>
              ))}
            </select>

            <br />

            <button onClick={handleUpdate} style={saveBtn}>
              Save
            </button>

            <button onClick={() => setEditStudent(null)} style={cancelBtn}>
              Cancel
            </button>
          </div>
        </div>
      )}
      {/* 🔽 Scroll Buttons */}
      <div style={scrollContainer}>
        <button onClick={scrollToTop} style={scrollBtn}>⬆</button>
        <button onClick={scrollToBottom} style={scrollBtn}>⬇</button>
      </div>

    </div>
  );
}

// 🎨 STYLES
const th = {
  border: "1px solid #ddd",
  padding: "10px",
  background: "#f5f5f5"
};

const td = {
  border: "1px solid #ddd",
  padding: "10px"
};

const inputStyle = {
  display: "block",
  width: "100%",
  marginBottom: "10px",
  padding: "8px",
  border: "1px solid #ccc",
  borderRadius: "5px"
};

const saveBtn = {
  padding: "8px 15px",
  background: "#16a34a",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  marginRight: "10px"
};

const cancelBtn = {
  padding: "8px 15px",
  background: "#dc2626",
  color: "#fff",
  border: "none",
  borderRadius: "5px"
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const popupStyle = {
  background: "#fff",
  padding: "25px",
  borderRadius: "10px",
  width: "400px"
};

const addStudentBtn = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "bold"
};

const searchBox = {
  padding: "8px",
  width: "300px",
  marginBottom: "15px",
  borderRadius: "6px",
  border: "1px solid #ccc"
};

const exportBtn = {
  padding: "8px 15px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

const printBtn = {
  padding: "8px 15px",
  background: "#16a34a",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

const actionBtn = {
  padding: "5px 10px",
  fontSize: "13px",
  borderRadius: "6px",
  border: "none",
  cursor: "pointer",
  fontWeight: "500",
  transition: "all 0.2s ease"
};

const editBtn = {
  ...actionBtn,
  background: "#e5e7eb",   // light gray
  color: "#111"
};

const deleteBtn = {
  ...actionBtn,
  background: "#dc2626",   // red
  color: "#fff"
};

const scrollContainer = {
  position: "fixed",
  right: "20px",
  bottom: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  zIndex: 999
};

const scrollBtn = {
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  border: "none",
  background: "#2563eb",
  color: "#fff",
  cursor: "pointer",
  fontSize: "18px",
  boxShadow: "0 4px 10px rgba(0,0,0,0.2)"
};

export default Students;